module.exports = __webpack_public_path__ + "static/parchhaiyaan-v2-2534fb08ac442ad6b088dbff34a6c6b8.png";